import { UserView } from "@saleor/products/customTypes/UserView";
import {
  ProductUserViewEnum,
  SmopUserTypeCode
} from "@saleor/types/globalTypes";
import { useState } from "react";

const userViews: UserView[] = Object.entries(ProductUserViewEnum).map(v => ({
  label: v[0]
    .split("_")
    .join(" ")
    .toUpperCase(),
  value: v[1]
}));

export default function useUserViewUpdate(
  userDetail,
  params
): [(e) => void, UserView, UserView[]] {
  function getInitialValueByUserType(userType, params) {
    return userType === SmopUserTypeCode.ACCOUNT_MANAGER ? params.viewAs : "";
  }

  function getInitialLabelByUserType(userType, params, userViews) {
    return userType === SmopUserTypeCode.ACCOUNT_MANAGER
      ? userViews.filter(u => u.value === params.viewAs)[0].label
      : "";
  }

  const initialUserView =
    userDetail &&
    userDetail.accessGroup &&
    userDetail.accessGroup.smopUsertypeCode &&
    userDetail.accessGroup.smopUsertypeCode ===
      SmopUserTypeCode.ACCOUNT_MANAGER &&
    params.viewAs === undefined
      ? SmopUserTypeCode.SELLER_MASTER
      : getInitialValueByUserType(
          userDetail.accessGroup !== null
            ? userDetail.accessGroup.smopUsertypeCode
            : "",
          params
        );
  const initialUserViewLabel =
    userDetail &&
    userDetail.accessGroup &&
    userDetail.accessGroup.smopUsertypeCode &&
    userDetail.accessGroup.smopUsertypeCode ===
      SmopUserTypeCode.ACCOUNT_MANAGER &&
    params.viewAs === undefined
      ? userViews.filter(
          u => u.value === (SmopUserTypeCode.SELLER_MASTER as string)
        )[0].label
      : getInitialLabelByUserType(
          userDetail.accessGroup !== null
            ? userDetail.accessGroup.smopUsertypeCode
            : "",
          params,
          userViews
        );

  const [userView, setUserView] = useState<UserView>({
    label: initialUserViewLabel,
    value: initialUserView
  });

  const handleUserViewChange = e => {
    setUserView({
      label: userViews.filter(u => u.value === e.target.value)[0].label,
      value: e.target.value
    });
  };

  return [handleUserViewChange, userView, userViews];
}
